import moment from 'moment';

Vue.filter('firstAndLastName', function(fullName) {
    const names = fullName.split(' ');
    let firstName;
    let lastName;
    if (!names || names.length <= 1) {
        firstName = names;
        lastName = '';
    } else {
        firstName = names[0];
        lastName = names.pop();
    }

    return `${firstName} ${lastName}`;
});

Vue.filter('capitalize_words', function (str) {
    if (!str) return '';
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
});

Vue.filter('formatFullDate', function(value) {
    if (value) {
        return moment(value).format('DD/MM/YYYY H:mm:ss')
    }
});

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
});

Vue.filter('formatHour', function(value) {
    if (value) {
        return moment(String(value)).format('H:mm:ss')
    }
});

Vue.filter('toCurrency', function (value) {
    let val = (value / 1).toFixed(2).replace('.', ',')
    return `R$ ${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
});

Vue.filter('monthViewEvent', function(value) {
    if (value) {
        return HelperJS.monthViewEvent(value);
    }

    return value;
})
